import 'client-only';

import { collectDealPackageNavigationTimings } from './collect-deal-package-navigation-timings.client';
import { emitDealPackageNavigationMetrics } from './emit-deal-package-navigation-metrics.client';
import { isDealPackageDocumentPathname } from './is-deal-package-document-pathname';
import { readDealPackageRouteCallerKindFromDocument } from './read-deal-package-route-caller-kind.client';

function readHasSubmissionIdFromUrl(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('submissionId');
}

/**
 * Reads `PerformanceNavigationTiming` for deal-package document loads and
 * reports queue/TTFB/transfer/DOM/load metrics to Sentry. Called once at SDK
 * init (before React hydrates) from `instrumentation-client.ts`.
 */
export function observeDealPackageDocumentNavigationOnInit(): void {
  try {
    if (typeof window === 'undefined') return;
    if (!isDealPackageDocumentPathname(window.location.pathname)) return;

    const report = () => {
      const timings = collectDealPackageNavigationTimings();
      if (!timings) return;
      emitDealPackageNavigationMetrics({
        timings,
        hasSubmissionId: readHasSubmissionIdFromUrl(),
        callerKind: readDealPackageRouteCallerKindFromDocument(),
      });
    };

    if (document.readyState === 'complete') {
      report();
      return;
    }

    window.addEventListener('load', () => setTimeout(report, 0), {
      once: true,
    });
  } catch {
    // Observability must never interrupt page initialization.
  }
}
